import styled from "styled-components";
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

export const musics = [
  {
    label: "Music video của năm",
    href: "/bang-xep-hang/1",
    image: "/images/music-1.jpg",
  },
  {
    label: "Bài hát của năm",
    href: "/bang-xep-hang/2",
    image: "/images/music-2.jpg",
  },
  {
    label: "Nam ca sĩ của năm",
    href: "/bang-xep-hang/4",
    image: "/images/music-3.jpg",
  },
  {
    label: "Nữ ca sĩ của năm",
    href: "/bang-xep-hang/3",
    image: "/images/music-4.jpg",
  },
  {
    label: "Nghệ sĩ mới của năm",
    href: "/bang-xep-hang/5",
    image: "/images/music-5.jpg",
  },
];
export const sports = [
  {
    label: "Gương mặt của năm",
    href: "/bang-xep-hang/6",
    image: "/images/sport-1.jpg",
  },
  {
    label: "Gương mặt trẻ của năm",
    href: "/bang-xep-hang/7",
    image: "/images/sport-2.jpg",
  },
];

const Header = () => {
  const [isActive, setActive] = useState(false);

  return (
    <Styles>
      <div className="bs-container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/images/logo-header.png" alt="" />
          </Link>

          <span
            className="show-menu"
            onClick={() => setActive((prev) => !prev)}
          >
            <i className="fas fa-bars" />
          </span>
          {isActive && (
            <div
              className="menu-layout"
              onClick={() => {
                setActive(false);
              }}
            />
          )}
          <ul className={"header-right" + (isActive ? " active" : "")}>
            <NavLink to="/" exact>
              <li>Trang chủ</li>
            </NavLink>
            <NavLink to="/the-le" exact>
              <li>Thể lệ</li>
            </NavLink>
            <li className="rank">
              <div className="rank-label">
                <div>Bảng xếp hạng</div>
                <img src="/images/right-arrow.png" alt="" />
              </div>
              <div className="popup">
                <div className="popup-content">
                  <div className="item">
                    <div>Âm nhạc</div>
                    <img src="/images/right-arrow.png" alt="" />
                    <div className="sub-popup">
                      <div className="sub-popup-content">
                        {musics.map((m, ind) => {
                          return (
                            <Link to={m.href} key={ind}>
                              {m.label}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div>Thể thao</div>
                    <img src="/images/right-arrow.png" alt="" />
                    <div className="sub-popup">
                      <div className="sub-popup-content">
                        {sports.map((m, ind) => {
                          return (
                            <Link to={m.href} key={ind + 100}>
                              {m.label}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </Styles>
  );
};

export default Header;

const Styles = styled.div`
  background: #212635;
  white-space: nowrap;
  color: white;
  height: 80px;
  .logo {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 44px;
    }
  }
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ul {
    display: flex;
    gap: 24px;
    li {
      padding: 0 20px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      border-bottom: 4px solid transparent;
    }
  }

  a.active,
  a:hover {
    li {
      background: -webkit-linear-gradient(right, #ff8a5a, #a15bff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 700;
    }
  }
  a.active {
    background-color: rgba(177, 184, 248, 0.06);
    li {
      border-bottom: 4px solid #aa60f0;
    }
  }

  .rank:hover {
    .popup-content {
      display: block;
    }
  }

  .rank {
    position: relative;
    cursor: pointer;
    .rank-label {
      display: flex;
      align-items: center;
      img {
        transform: rotate(90deg);
      }
    }
    .popup {
      position: absolute;
      top: 64px;
      left: 20px;
      right: 20px;
      font-size: 16px;
      z-index: 11;
    }

    .popup-content {
      display: none;
      padding: 8px;
      border-radius: 4px;
      box-shadow: 8px 8px 10px rgba(64, 143, 187, 0.06);
      background: #2a3045;
      position: relative;
    }

    .item {
      padding: 10px 8px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      :hover {
        background-color: rgba(255, 255, 255, 0.05);
        font-weight: 700;
        .sub-popup {
          display: block;
        }
      }
    }

    .sub-popup-content {
      background: #2a3045;
      margin-left: 12px;
      padding: 8px;
    }

    .sub-popup {
      display: none;
      position: absolute;
      right: 8px;
      top: 0;

      border-radius: 4px;
      transform: translateX(100%);
      font-weight: 300;
      a {
        padding: 10px 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        :hover {
          background-color: rgba(255, 255, 255, 0.05);
          color: white;
        }
      }
    }
    img {
      margin-left: 8px;
    }
  }

  .show-menu {
    display: none;
  }

  @media only screen and (max-width: 1600px) {
    ul {
      padding-right: 180px;
    }
  }

  @media only screen and (max-width: 991px) {
    .show-menu {
      display: block;
      font-size: 24px;
    }

    .menu-layout {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 98;
    }

    .header-right.active {
      transform: translateX(0);
    }
    .header-right {
      transform: translateX(-100%);
      transition: 0.3s;
      width: 300px;
      position: fixed;
      z-index: 99;
      top: 0;
      left: 0;
      bottom: 0;
      flex-direction: column;
      background-color: #212635;
      overflow: auto;
    }
    ul {
      padding: 50px 0;
      margin: 0;
      li {
        align-items: flex-start;
        justify-content: flex-start;
        border-bottom: unset !important;
        height: unset;
      }
      img {
        display: none;
      }
    }

    .rank {
      position: unset;
      display: block;
      .popup {
        position: unset;
      }

      .popup-content {
        background: none;
        display: block;
      }

      .sub-popup {
        position: unset;
        transform: unset;
        background: none;
        display: block !important;
      }

      .sub-popup-content {
        background: none;
        margin-left: unset;
      }

      .item {
        flex-direction: column;
        align-items: unset;
        background: none !important;
      }
    }
  }
`;
